import { render, staticRenderFns } from "./ResultAll.vue?vue&type=template&id=28204494&scoped=true&"
import script from "./ResultAll.vue?vue&type=script&lang=js&"
export * from "./ResultAll.vue?vue&type=script&lang=js&"
import style0 from "./ResultAll.vue?vue&type=style&index=0&id=28204494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28204494",
  null
  
)

export default component.exports